import React from "react";
import CVMTable from "./CVMTable/CVMTable";

export default function CVMCard(props) {
    const { cvm_data } = props
    const hasSource = Object.keys(cvm_data?.source || {}).length > 0;
    if (!hasSource) return null;
    return (
        <div style={{width: "100%", border: '1px solid #dedede', borderRadius: '8px', padding: '16px'}}>
            <p style={{fontSize: "14px", fontWeight: "bold", margin: "0 0 16px 0", padding: 0, color: '#0b1f82'}}>
                CVM - Match encontrado
            </p>
            <CVMTable cvm_data={cvm_data.source} />
        </div>
    )
}
